const NON_VL_STATUS_VALUES = new Set([
  'Verified_NonVL',
  'List_NonVL',
  'Delist_NonVL',
  'DelistInProgress_NonVL',
  'Return_NonVL',
  'Unsold_NonVL',
]);

const NON_VL_STATUS_LABELS: Record<string, string> = {
  Verified_NonVL: 'Verified (Non-VL)',
  List_NonVL: 'Listed (Non-VL)',
  Delist_NonVL: 'Delisted (Non-VL)',
  DelistInProgress_NonVL: 'Delist Requested (Non-VL)',
  Return_NonVL: 'Returned (Non-VL)',
  Unsold_NonVL: 'Unsold (Non-VL)',
};

/** True when the target status is a Non-VL (QA-only) transition. */
export function isNonVlStatusChange(status: string | null | undefined): boolean {
  const key = String(status || '').trim();
  if (!key) return false;
  if (NON_VL_STATUS_VALUES.has(key)) return true;
  const normalized = key.toLowerCase().replace(/[^a-z]/g, '');
  return normalized.endsWith('nonvl');
}

export function getNonVlStatusDisplayLabel(status: string): string {
  const key = String(status || '').trim();
  return NON_VL_STATUS_LABELS[key] || key.replace(/_/g, ' ');
}

export function buildNonVlStatusConfirmSummary(
  targetStatus: string,
  ticketCount: number,
): string {
  const label = getNonVlStatusDisplayLabel(targetStatus);
  const ticketLabel = ticketCount > 1 ? `${ticketCount} tickets` : 'this ticket';
  return `Do you want to change ${ticketLabel} to ${label}? This is a Non-VL update (QuickAsyst only — Victory Live is not changed).`;
}
